<template>
  <div class="row q-pa-md items-center">
    <div style="display: inline-block" class="text-h6">Draw Lanes</div>
    <div class="col-12">
      <div class="row">
        <div class="col-12 q-pa-sm">
          <q-card>
            <q-card-section>
              <div class="row">
                <div class="col-12 col-sm-2 col-md-1 q-px-xs">
                  <span>Entries</span>
                  <p class="q-mt-sm q-mb-none">
                    {{ registeredParticipants.length }}
                  </p>
                </div>
                <div class="col-6 col-sm-2 col-md-1 q-px-xs">
                  <span> Lanes </span>
                  <q-select
                    v-model="lanes"
                    v-bind="siteCFG.fields.general"
                    :options="laneAvailableOptions"
                    dense
                  >
                  </q-select>
                  <!-- <q-input v-bind="siteCFG.fields.general"></q-input> -->
                </div>
                <div class="col-6 col-sm-2 col-md-1 q-px-xs">
                  <span> Rounds </span>
                  <q-select
                    v-model="rounds"
                    v-bind="siteCFG.fields.general"
                    :options="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                    dense
                  >
                  </q-select>
                </div>
                <div class="col-6 col-sm-2 col-md-3 q-px-xs">
                  <span> Qual/Race </span>
                  <q-select
                    :disable="
                      lanes >= registeredParticipants.length ||
                        rounds != 1 ||
                        ((this.competition.lane_order_type ==
                          'Centre Lane Out' ||
                          this.competition.lane_order_type ==
                            'First Lane Out') &&
                          this.competition.qualifyingTimesOrMarks == 1)
                    "
                    v-model="qualPerRace"
                    v-bind="siteCFG.fields.general"
                    :options="qualPerRaceOptions"
                    option-label="label"
                    option-value="value"
                    :emit-value="true"
                    map-options
                    dense
                  >
                  </q-select>
                </div>
                <div class="col-6 col-sm-4 col-md-3 q-px-xs">
                  <span> Total Qualifiers </span>
                  <q-select
                    v-if="
                      lanes >= registeredParticipants.length ||
                        rounds != 1 ||
                        ((this.competition.lane_order_type ==
                          'Centre Lane Out' ||
                          this.competition.lane_order_type ==
                            'First Lane Out') &&
                          this.competition.qualifyingTimesOrMarks == 1)
                    "
                    :disable="
                      rounds == 1 &&
                        (!event.combinedEvents ||
                          event.combinedEvents.length == 0) &&
                        this.competition.lane_order_type != 'Centre Lane Out' &&
                        this.competition.lane_order_type != 'First Lane Out'
                    "
                    v-model="totalQual"
                    v-bind="siteCFG.fields.general"
                    :options="totalQualOptions"
                    option-label="label"
                    option-value="value"
                    :emit-value="true"
                    map-options
                    dense
                  >
                  </q-select>
                  <p v-else class="q-mt-sm q-mb-none">
                    {{
                      laneOptions.heatsPerRound * qualPerRace >
                      registeredParticipants.length
                        ? registeredParticipants.length
                        : laneOptions.heatsPerRound * qualPerRace
                    }}
                  </p>
                </div>
                <div class="col-12 col-md-3 q-px-xs">
                  <span> Progress To </span>
                  <q-select
                    :disable="
                      rounds == 1 &&
                        (lanes >= registeredParticipants.length ||
                          rounds != 1) &&
                        (!event.combinedEvents ||
                          event.combinedEvents.length == 0)
                    "
                    v-model="progressTo"
                    v-bind="siteCFG.fields.general"
                    :options="progressToOptions"
                    option-label="label"
                    option-value="value"
                    :emit-value="true"
                    map-options
                    dense
                  >
                  </q-select>
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col-12">
          <q-scroll-area
            :style="
              `height: calc(100vh - ${
                $q.screen.lt.sm ? '550px' : '430px'
              }) !important`
            "
          >
            <div
              class="row"
              v-for="(round, index) in laneOptions.eventRounds"
              :key="`round_${index}`"
            >
              <div class="col-12">{{ round.label }}</div>

              <div
                class="q-pa-md"
                v-for="(heat, heatIndex) in round.heats"
                :key="`round_${index}_heat_${heatIndex}`"
              >
                <q-card style="width: 100px">
                  <q-card-section>
                    <b>{{ heat.label }}</b>
                    {{ heat.participants.length }}
                  </q-card-section>
                </q-card>
              </div>
            </div>
            <div
              class="row"
              v-if="
                progressToRoundStructureLookup[progressTo].round &&
                  (lanes < registeredParticipants.length || rounds != 1)
              "
              v-for="(round, index) in progressToRoundStructureLookup[
                progressTo
              ].rounds"
              :key="`progressToRounds_${index}`"
            >
              <div class="col-12">{{ round.label }}</div>

              <div
                class="q-pa-md"
                v-for="(card, cardIndex) in round.cards"
                :key="`card_${cardIndex}`"
              >
                <q-card style="width: 100px">
                  <q-card-section>
                    <b>{{ card.label }}</b>
                    {{ card.participants }}
                  </q-card-section>
                </q-card>
              </div>
            </div>
          </q-scroll-area>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
// import { Notify } from "quasar";

export default {
  components: {},
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      siteCFG: "settings/siteCFG",
      registeredParticipants: "events/registeredParticipants",
      event: "events/current",
      competition: "competitions/current"
    })
  },
  data: () => ({
    rfid: "",
    rounds: 1,
    lanes: 8,
    qualPerRace: "None",
    totalQual: 0,
    progressTo: 0,
    qualPerRaceOptions: [
      {
        label: "None",
        value: 0
      }
    ],
    totalQualOptions: [
      {
        label: "None",
        value: 0
      }
    ],
    progressToOptions: [
      {
        label: "Choose",
        value: 0
      },
      {
        label: "1x Final",
        value: 1
      },
      {
        label: "2x Semi",
        value: 2
      },
      {
        label: "3x Semi",
        value: 3
      },
      {
        label: "3x Quater",
        value: 7
      },
      {
        label: "4x Quater",
        value: 4
      },
      {
        label: "5x Quater",
        value: 8
      },
      {
        label: "6x Quater",
        value: 9
      },
      {
        label: "7x Quater",
        value: 10
      },
      {
        label: "Placings by Points",
        value: 5
      },
      {
        label: "Placings by Times",
        value: 6
      }
    ],
    progressToRoundStructureLookup: [
      {
        round: false
      },
      {
        round: true,
        rounds: [
          {
            label: "Final",
            cards: [
              {
                label: "F1",
                participants: 0
              }
            ]
          }
        ]
      },
      {
        round: true,
        rounds: [
          {
            label: "Semi Finals",
            cards: [
              {
                label: "S1",
                participants: 0
              },
              {
                label: "S2",
                participants: 0
              }
            ]
          }
        ]
      },
      {
        round: true,
        rounds: [
          {
            label: "Semi Finals",
            cards: [
              {
                label: "S1",
                participants: 0
              },
              {
                label: "S2",
                participants: 0
              },
              {
                label: "S2",
                participants: 0
              }
            ]
          }
        ]
      },
      {
        round: true,
        rounds: [
          {
            label: "Quarter Finals",
            cards: [
              {
                label: "Q1",
                participants: 0
              },
              {
                label: "Q2",
                participants: 0
              },
              {
                label: "Q3",
                participants: 0
              },
              {
                label: "Q4",
                participants: 0
              }
            ]
          }
        ]
      },

      {
        round: false
      },
      {
        round: false
      },
      {
        round: true,
        rounds: [
          {
            label: "Quarter Finals",
            cards: [
              {
                label: "Q1",
                participants: 0
              },
              {
                label: "Q2",
                participants: 0
              },
              {
                label: "Q3",
                participants: 0
              }
            ]
          }
        ]
      },
      {
        round: true,
        rounds: [
          {
            label: "Quarter Finals",
            cards: [
              {
                label: "Q1",
                participants: 0
              },
              {
                label: "Q2",
                participants: 0
              },
              {
                label: "Q3",
                participants: 0
              },
              {
                label: "Q4",
                participants: 0
              },
              {
                label: "Q5",
                participants: 0
              }
            ]
          }
        ]
      },
      {
        round: true,
        rounds: [
          {
            label: "Quarter Finals",
            cards: [
              {
                label: "Q1",
                participants: 0
              },
              {
                label: "Q2",
                participants: 0
              },
              {
                label: "Q3",
                participants: 0
              },
              {
                label: "Q4",
                participants: 0
              },
              {
                label: "Q5",
                participants: 0
              },
              {
                label: "Q6",
                participants: 0
              }
            ]
          }
        ]
      },
      {
        round: true,
        rounds: [
          {
            label: "Quarter Finals",
            cards: [
              {
                label: "Q1",
                participants: 0
              },
              {
                label: "Q2",
                participants: 0
              },
              {
                label: "Q3",
                participants: 0
              },
              {
                label: "Q4",
                participants: 0
              },
              {
                label: "Q5",
                participants: 0
              },
              {
                label: "Q6",
                participants: 0
              },
              {
                label: "Q7",
                participants: 0
              }
            ]
          }
        ]
      }
    ],

    laneOptions: {
      heatsPerRound: 0,
      overFlowAmount: 0,
      fullHeats: 0,
      eventRounds: []
    },

    laneAvailableOptions: []
  }),
  watch: {
    rounds: function() {
      this.drawLanes();
    },
    lanes: function() {
      this.drawLanes();
    },
    qualPerRace: function() {
      this.drawLanes();
    },
    totalQual: function() {
      this.drawLanes();
    },
    progressTo: function() {
      this.drawLanes();
    },
    registeredParticipants: function() {
      // Generating an array of options for number of lanes available
      // if (this.competition.competition_type == "BEACH") {
      this.laneAvailableOptions = Array.from(
        {
          length:
            this.competition.default_num_lanes <
            this.registeredParticipants.length
              ? this.registeredParticipants.length
              : this.competition.default_num_lanes
        },
        (_, i) => i + 1
      );
      // } else if (this.event.num_lanes) {
      //   this.laneAvailableOptions = Array.from(
      //     { length: this.event.num_lanes },
      //     (_, i) => i + 1
      //   );
      // } else {
      //   this.laneAvailableOptions = Array.from(
      //     { length: this.registeredParticipants.length },
      //     (_, i) => i + 1
      //   );
      // }

      if (this.competition.competition_type == "BEACH") {
        if (this.competition.default_num_lanes) {
          this.lanes =
            this.competition.default_num_lanes >
            this.registeredParticipants.length
              ? this.registeredParticipants.length
              : this.competition.default_num_lanes;
        } else if (this.event.num_lanes) {
          this.lanes =
            this.event.num_lanes > this.registeredParticipants.length
              ? this.registeredParticipants.length
              : this.event.num_lanes;
        } else if (this.event.disciplineNumLanes) {
          this.lanes =
            this.event.disciplineNumLanes > this.registeredParticipants.length
              ? this.registeredParticipants.length
              : this.event.disciplineNumLanes;
        } else {
          this.lanes =
            this.registeredParticipants.length >
            this.laneAvailableOptions.length
              ? this.laneAvailableOptions.length
              : this.registeredParticipants.length;
        }
      } else {
        if (this.competition.default_num_lanes) {
          this.lanes = this.competition.default_num_lanes;
        } else if (this.event.num_lanes) {
          this.lanes = this.event.num_lanes;
        } else if (this.event.disciplineNumLanes) {
          this.lanes = this.event.disciplineNumLanes;
        } else {
          this.lanes =
            this.registeredParticipants.length >
            this.laneAvailableOptions.length
              ? this.laneAvailableOptions.length
              : this.registeredParticipants.length;
        }
      }

      this.drawLanes();
    }
  },
  mounted() {
    this.$store.dispatch("events/loadRegisteredParticipants", this.event.id);

    this.drawLanes();
  },
  methods: {
    addMember() {},
    drawLanes() {
      // Calculating the amount of Full Heats
      this.laneOptions.fullHeats = Math.floor(
        this.registeredParticipants.length / this.lanes
      );

      // Calculating the Overflow amount
      this.laneOptions.overFlowAmount =
        this.registeredParticipants.length % this.lanes;

      // Calculating the amount of heats per round
      this.laneOptions.heatsPerRound =
        this.registeredParticipants.length % this.lanes > 0 ? 1 : 0;
      this.laneOptions.heatsPerRound += this.laneOptions.fullHeats;

      // Calculating the Qual Options
      this.totalQualOptions = [
        {
          label: "None",
          value: 0
        }
      ];

      // Populating the Total qual options list for dropdown
      this.registeredParticipants.forEach(element => {
        if (element.value == 1) {
          this.totalQualOptions.push({
            label: `${this.totalQualOptions.length}`,
            value: this.totalQualOptions.length
          });
        }
      });

      // Building the rounds object
      this.generateRounds();

      // Generating the Qualifiers per race dropdown List
      if (this.lanes < this.registeredParticipants.length && this.rounds == 1) {
        this.qualPerRaceOptions = [
          {
            label: "None",
            value: 0
          }
        ];
        for (
          let i = 1;
          i <= this.laneOptions.eventRounds[0].heats[0].participants.length;
          i++
        ) {
          this.qualPerRaceOptions.push({
            label: `Top ${i}`,
            value: i
          });
        }
      } else {
        this.qualPerRace = 0;
      }

      let totalQualifiers;
      if (
        this.progressToRoundStructureLookup[this.progressTo].round &&
        (this.lanes < this.registeredParticipants.length || this.rounds != 1)
      ) {
        if (
          this.lanes >= this.registeredParticipants.length ||
          this.rounds != 1
        ) {
          // Calculating Total Qualifiers from Total Qualifiers drop down
          totalQualifiers = this.totalQual;
        } else {
          // Calculating Total Qualifiers from "Qualifiers Per Race"
          totalQualifiers = this.laneOptions.heatsPerRound * this.qualPerRace;
          totalQualifiers =
            totalQualifiers > this.registeredParticipants.length
              ? this.registeredParticipants.length
              : totalQualifiers;
        }

        let qualPerRound = Math.floor(
          totalQualifiers /
            this.progressToRoundStructureLookup[this.progressTo].rounds[0].cards
              .length
        );

        qualPerRound = qualPerRound == 0 ? 1 : qualPerRound;

        this.progressToRoundStructureLookup[
          this.progressTo
        ].rounds[0].cards.forEach(card => {
          card.participants =
            totalQualifiers >= qualPerRound ? qualPerRound : totalQualifiers;

          totalQualifiers = totalQualifiers - qualPerRound;
          totalQualifiers = totalQualifiers < 0 ? 0 : totalQualifiers;
        });

        for (let i = 0; i < totalQualifiers; i++) {
          this.progressToRoundStructureLookup[this.progressTo].rounds[0].cards[
            i
          ].participants += 1;
        }
      }
    },

    generateRounds() {
      this.laneOptions.eventRounds = [];
      let participantPerEvent = Math.floor(
        this.registeredParticipants.length / this.laneOptions.heatsPerRound
      );

      let overflow =
        this.registeredParticipants.length % this.laneOptions.heatsPerRound;

      let roundName =
        this.rounds == 1 && this.lanes >= this.registeredParticipants.length
          ? "Final"
          : this.rounds == 1
          ? "Heats"
          : "Round";
      let heatName =
        this.rounds == 1 && this.lanes >= this.registeredParticipants.length
          ? "F"
          : "H";

      for (let ri = 0; ri < this.rounds; ri++) {
        let round = {
          label: `${roundName} ${ri + 1}`,
          roundPos: ri,
          heats: []
        };

        let seededParticipants;
        if (
          (this.competition.lane_order_type == "Centre Lane Out" ||
            this.competition.lane_order_type == "First Lane Out") &&
          this.event.playerLabels &&
          JSON.parse(this.event.playerLabels).length > 0
        ) {
          // Slowest to fastest middle out (Null, then Largest Qual time down)
          let tempParticipants = this.$options.filters.shuffle(
            JSON.parse(JSON.stringify(this.registeredParticipants))
          );
          seededParticipants = tempParticipants.sort((a, b) => {
            if (!a.qualMark) {
              return -1;
            }
            if (!b.qualMark) {
              return 1;
            }
            let aNumber = a.qualMark.replace(":", "");
            let bNumber = b.qualMark.replace(":", "");
            if (
              Number(aNumber.replace(".", "")) >
              Number(bNumber.replace(".", ""))
            ) {
              return -1;
            }
            return 1;
          });
        } else {
          // Random
          seededParticipants = this.$options.filters.shuffle(
            this.registeredParticipants
          );
        }

        let currentParticipant = 0;

        if (
          (this.competition.lane_order_type == "Centre Lane Out" ||
            this.competition.lane_order_type == "First Lane Out") &&
          this.event.playerLabels &&
          JSON.parse(this.event.playerLabels).length > 0 &&
          this.competition.qualifyingTimesOrMarks == 1
        ) {
          seededParticipants = seededParticipants.reverse();
          // This will create the heats from slowest to fastest, filling the faster lanes first.
          // eslint-disable-next-line for-direction
          for (let hi = this.laneOptions.heatsPerRound - 1; hi >= 0; hi--) {
            let heat = {
              label: `${heatName}${hi + 1}`,
              heatPos: hi,
              participants: []
            };

            let heatParticipants = [];

            // Getting Participants for Heat
            for (let pi = 0; pi < this.lanes; pi++) {
              if (pi < seededParticipants.length) {
                heatParticipants.push(seededParticipants[pi]);
              }
            }

            seededParticipants.splice(0, heatParticipants.length);

            // Sorting by Center Out
            let offset = 0;
            if (this.competition.lane_order_type == "Centre Lane Out") {
              let newHeatParticipants = [];
              for (let pi = 0; pi < heatParticipants.length; pi++) {
                if (pi % 2 > 0) {
                  newHeatParticipants.push(heatParticipants[pi]);
                } else {
                  newHeatParticipants.unshift(heatParticipants[pi]);
                }
              }
              heatParticipants = newHeatParticipants;
              offset =
                this.$options.filters.findFirstFilledLane(
                  this.lanes,
                  heatParticipants.length
                ) - 1;
            }

            // Adding Participants to List
            heatParticipants.forEach((p, index) => {
              heat.participants.push({
                id: p.ref_id,
                events_id: p.events_id,
                lane: index + offset + this.competition.first_lane_no,
                pos: index + currentParticipant
              });
            });

            round.heats.push(heat);
          }

          round.heats.reverse();
        } else {
          for (let hi = 0; hi < this.laneOptions.heatsPerRound; hi++) {
            let heat = {
              label: `${heatName}${hi + 1}`,
              heatPos: hi,
              participants: []
            };

            let heatParticipants = [];

            // Getting Participants for Heat
            let participantsCount =
              hi < overflow ? participantPerEvent + 1 : participantPerEvent;
            for (let pi = 0; pi < participantsCount; pi++) {
              if (
                pi + currentParticipant <
                this.registeredParticipants.length
              ) {
                heatParticipants.push(
                  seededParticipants[pi + currentParticipant]
                );
              }
            }
            currentParticipant += participantsCount;

            // Sorting by Center Out
            let offset = 0;
            if (this.competition.lane_order_type == "Centre Lane Out") {
              let newHeatParticipants = [];
              for (let pi = heatParticipants.length - 1; pi >= 0; pi--) {
                if (pi % 2 > 0) {
                  newHeatParticipants.push(heatParticipants[pi]);
                } else {
                  newHeatParticipants.unshift(heatParticipants[pi]);
                }
              }
              heatParticipants = newHeatParticipants;
              offset =
                this.$options.filters.findFirstFilledLane(
                  this.lanes,
                  heatParticipants.length
                ) - 1;
            }

            // Adding Participants to List
            heatParticipants.forEach((p, index) => {
              heat.participants.push({
                id: p.ref_id,
                events_id: p.events_id,
                lane: index + offset + this.competition.first_lane_no,
                pos: index + currentParticipant
              });
            });

            round.heats.push(heat);
          }
        }

        this.laneOptions.eventRounds.push(round);
      }
    },

    async updateProgress() {
      let payload = {
        laneOptions: this.laneOptions,
        lanes: this.lanes,
        progressTo: this.progressTo,
        qualPerRace: this.qualPerRace,
        rounds: this.rounds,
        totalQual: this.totalQual,
        events_id: this.$route.params.events_id
      };
      await this.$store
        .dispatch("eventProgress/drawLanes", payload)
        .then(result => {
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    }
  }
};
</script>
